
import React, { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { IzakayaHero } from '../tokyo-izakaya-night/components/IzakayaHero';
import { IzakayaBadgeBanner } from '../tokyo-izakaya-night/components/IzakayaBadgeBanner';
import { IzakayaConcept } from '../tokyo-izakaya-night/components/IzakayaConcept';
import { IzakayaTimeline } from '../tokyo-izakaya-night/components/IzakayaTimeline';
import { IzakayaArea } from '../tokyo-izakaya-night/components/IzakayaArea';
import { IzakayaShops } from '../tokyo-izakaya-night/components/IzakayaShops';
import { IzakayaGallery } from '../tokyo-izakaya-night/components/IzakayaGallery';
import { IzakayaPricing } from '../tokyo-izakaya-night/components/IzakayaPricing';
import { IzakayaFaq } from '../tokyo-izakaya-night/components/IzakayaFaq';
import { IzakayaNotice } from '../tokyo-izakaya-night/components/IzakayaNotice';
import { IzakayaWhatsAppButton } from '../tokyo-izakaya-night/components/IzakayaWhatsAppButton';
import { IzakayaFinalCta } from '../tokyo-izakaya-night/components/IzakayaFinalCta';

export default function TokyoIzakayaNightEnPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <IzakayaHero lang="en" />
      <IzakayaBadgeBanner lang="en" />
      <IzakayaConcept lang="en" />
      <IzakayaTimeline lang="en" />
      <IzakayaArea lang="en" />
      <IzakayaShops lang="en" />
      <IzakayaGallery lang="en" />
      <IzakayaPricing lang="en" />
      <IzakayaFaq lang="en" />
      <IzakayaFinalCta lang="en" />
      <IzakayaNotice lang="en" />
      <IzakayaWhatsAppButton lang="en" />
      <Footer />
    </div>
  );
}
